import styled from 'styled-components';

interface noteProps {
  textareaSelected: boolean;
}

export const Container = styled.div<noteProps>`
  background: #202020;
  border-radius: 15px;

  p {
    color: #606060;
    font-size: 0.8rem;
  }

  button {
    cursor: text !important;
  }

  textarea {
    background: #202020;
    border: none;
    color: #606060;
    min-height: ${(props) => (props.textareaSelected ? '100%' : '92.5%')};

    :focus {
      background: #202020;
      box-shadow: none;
      color: #606060;
    }
  }

  @media screen and (max-width: 991px) {
    min-height: ${(props) => (props.textareaSelected ? '210px' : '200px')};
  }
`;
